import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../app-settings';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CashRegisterService {


  private formHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  };

  constructor(private http: HttpClient) { }

  getCashRegistersByBussiness(id_business: number) {
    let url = `${AppSettings.API_URI_V2}/company/${id_business}/cash-registers`;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  checkCashRegisterStatus(id_business: number, id_cash_register: number) {
    let url = `${AppSettings.API_URI_V2}/company/${id_business}/session-cash-register/status/${id_cash_register}`;
    return this.http.get<any>(url, {}).pipe(
      map(data => {
        return data;
      })
    );
  }

  startWorkTime(id_business: number, payload: any) {
    let url = `${AppSettings.API_URI_V2}/company/${id_business}/session-cash-register/start`;
    return this.http.post<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  closeWorkTime(id_business: number, id_cash_register: number) {
    const url = `${AppSettings.API_URI_V2}/company/${id_business}/session-cash-register/close/${id_cash_register}`;
    return this.http.put<any>(url,{}).pipe(
      map(data => {
        return data;
      })
    );
  }

}
